import {DateTime} from 'luxon';
import {StacCollection} from '@src/types/configurations.ts';

export type CollectionDateTimeRange = {
  from: DateTime | null;
  to: DateTime | null;
};

export type CollectionDateTimeRangeWithDefault = Required<{
  [K in keyof CollectionDateTimeRange]: NonNullable<CollectionDateTimeRange[K]>;
}>;

export const parseDateTimeFromCollection = (
  collection?: StacCollection,
): CollectionDateTimeRange => {
  const [from, to] = collection?.extent?.temporal?.interval?.[0] || [];

  return {
    from: from ? DateTime.fromISO(from) : null,
    to: to ? DateTime.fromISO(to) : null,
  };
};

export const parseDateTimeFromCollectionWithDefaults = (
  collection?: StacCollection,
): CollectionDateTimeRangeWithDefault => {
  const {from, to} = parseDateTimeFromCollection(collection);

  const effectiveTo = to ?? DateTime.now();
  const effectiveFrom = from ?? effectiveTo.minus({months: 1});

  return {
    from: effectiveFrom.startOf('day'),
    to: effectiveTo.endOf('day'),
  };
};
